import { Injectable } from '@angular/core';
import { AddParkeUserRequest } from '@core/models/api-response.model';
import { APIService } from '@core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ParkerService {

  constructor(
    private readonly apiService: APIService,
  ) { }

  addGroupUsersDriver(request:AddParkeUserRequest){
   return this.apiService.postWithAllResponse('User/AddGroupUsersDriver',request);
  }

  getGroupUserDriverListByGroupUserId(request){
    return this.apiService.postWithAllResponse('User/GetGroupUserDriverListByGroupUserId',request);
  }

  deleteGroupUserDriverById(id:string,isConfirmDelete:boolean){
    return this.apiService.delete(`User/DeleteGroupUserDriverById?id=${id}&isConfirmDelete=${isConfirmDelete}`);
  }
}
